import React, { Component } from "react";
import Navigation from "./Navigation";
import PeriodicTable from "./PeriodicTable";
import { Link } from "react-router-dom";

import health from "./img/icon-healthcare.svg";
import retail from "./img/icon-retail.svg";
import education from "./img/icon-highered.svg";

import imgOne from "./img/Higher-Ed/eSports-controller-icon_2-color.svg";
import imgTwo from "./img/Higher-Ed/data-center-mainframe-icon_2-color.svg";

import "./css/SelectVertical.scss";
import "./css/animate.css";
import higherEdData from "./data/higherEd.json";

class HigherEd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      headerAnimate: "fadeInUp",
      verticalAnimate: "animated bounceInUp",
      verticalSelected: false
    };
  }

  verticalClick(e) {
    this.setState({
      headerAnimate: "fadeOutUp",
      verticalAnimate: "animated bounceOutUp",
      verticalSelected: true,
      verticalName: e.target.dataset.vertical
    });

    console.log(e.target.dataset.vertical);
  }

  render() {
    return (
      <div className="SelectVertical">
        <h2 className={"animated " + this.state.headerAnimate}>
          Higher Education
        </h2>

        <div
          className={
            "vertical health vertical1 " +
            (this.state.verticalName === "health"
              ? "moveUpHealth"
              : this.state.verticalAnimate)
          }
        >
          <img src={imgOne} data-vertical="health" />
          <h3>eSports Gaming</h3>
          <Link
            to={{
              pathname: "/case",
              state: {
                contentTitle: higherEdData.higherEd[0].title,
                image: imgOne,
                subTitle: higherEdData.higherEd[0].subTitle,
                elements: higherEdData.higherEd[0].elements,
                content: higherEdData.higherEd[0].content
              }
            }}
          >
            <button>Compete</button>
          </Link>
        </div>

        <div
          className={"vertical retail vertical2 " + this.state.verticalAnimate}
        >
          <img src={imgTwo} data-vertical="retail" />
          <h3>High-Performance Computing</h3>
          <Link
            to={{
              pathname: "/case",
              state: {
                contentTitle: higherEdData.higherEd[1].title,
                image: imgTwo,
                subTitle: higherEdData.higherEd[1].subTitle,
                elements: higherEdData.higherEd[1].elements,
                content: higherEdData.higherEd[1].content
              }
            }}
          >
            <button>Protect</button>
          </Link>
        </div>
      </div>
    );
  }
}

export default HigherEd;
